<template>
    <div>
        <div id="table_box">
            <div class="search_box">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="合同名称">
                        <el-input v-model="form.contactName" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="款项名称" v-if="innerTableType == 11">
                        <el-input v-model="form.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="合同编号" v-if="innerTableType == 10">
                        <el-input v-model="form.contactCode" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="变更名称" v-if="innerTableType == 12">
                        <el-input v-model="form.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="变更类型" v-if="innerTableType == 12">
                        <el-select v-model="form.region" placeholder="请选择活动区域" size="small">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="事项名称" v-if="innerTableType == 13 || innerTableType == 14 || innerTableType == 15">
                        <el-input v-model="form.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" v-if="innerTableType == 11 || innerTableType == 12 || innerTableType == 13 || innerTableType == 14 || innerTableType == 15">
                        <el-select v-model="form.region" placeholder="请选择活动区域" size="small">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="text" class="fr" @click="getData">查询</el-button>
                </el-form>
            </div>
            <div v-if="innerTableType == 10" key="10">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="contractName"
                        label="合同名称">
                    </el-table-column>
                    <el-table-column
                        prop="contactCode"
                        label="合同编号">
                    </el-table-column>
                    <el-table-column
                        prop="supplierCategoryName"
                        label="服务分类">
                    </el-table-column>
                    <el-table-column
                        prop="evaluationType"
                        label="评估类型">
                        <template slot-scope="scope">
                            <label v-if="scope.row.evaluationType===1">过程平台</label>
                            <label v-else>后评估</label>
                        </template>
                    <!-- 1：过程平台，2：后评估-->
                    </el-table-column>
                    <el-table-column
                        prop="evaluationYear"
                        label="评估年度">
                    </el-table-column>
                    <el-table-column
                        prop="evaluationScore"
                        label="履约得分">
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="contract(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 11" key="11">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="款项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="付款时间"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="应付金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="已付金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="应付未付金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="状态"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text">发起申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 12" key="12">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="变更名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="变更类型"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="变更申请金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="变更审批金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="状态"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text">发起申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 13" key="13">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="事项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="申报金额（含税）"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="申报金额（除税）"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="状态"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text">发起申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 14" key="14">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="事项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="竣工日期"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="质保期满日期"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="质保金金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="状态"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text">发起申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="innerTableType == 15" key="15">
                <el-table :data="tableData" :header-cell-style="tableHeaderStyle"
                          style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="合同名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="事项名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="竣工日期"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="质保期满日期"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="质保金金额"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="状态"
                    >
                    </el-table-column>
                    <el-table-column width="200"
                                     label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text">发起申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="float: right;margin-top: 30px;">
                <el-pagination
                    background
                    layout="prev, pager, next,jumper"
                    :total="dataCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'bidTable',
        data(){
            return {
                form: {
                    "contactCode": null,
                    "contactName": null,
                    "contractStatus": null,
                    "detailStatus": null,
                    "nodeName": null,
                    "orderCode": null,
                    "orderName": null,
                    "orderStatus": null,
                    "pageFlag": 1,
                    "pageNumber": 1,
                    "pageSize": 10,
                    "projectName": null
                },
                tableData: [],
                dataCount:0,
                tableHeaderStyle:{
                    'background-color': '#F6F6F6',
                    'height': '40px',
                    'color': '#333333',
                },
                innerTableType:1
            }
        },
        components: {
        },
        created(){
            this.getData()
        },
        props:{
//            innerTableType:{
//                type: Number
//            }
        },
        methods:{
            contract(val){
                this.$router.push('/contract/see/'+val.id)
            },
            resetSearch(){
            },
            changeType(innerTableType){
                this.innerTableType = innerTableType;
                this.resetSearch();
                console.log(innerTableType)
            },
            getData(){
                let that = this;
                let params = Object.assign({}, this.form);
                let url = '/v1/outerformflowHS/getSevaluationList';
                this.$root.postHttp(url, params, (res) => {
                    that.tableData = res.data.data.list;
                    that.dataCount = res.data.data.count;
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../assets/_var.scss';
    .search_box{
        text-align: left;
        .el-form-item /deep/{
            width: 300px;
            display: inline-block;
            .el-input__inner{
                border-radius: 0!important;
            }
        }
        .fr{
            float: right;
            color: #333333;
            font-size: 16px;
        }
    }
    #table_box /deep/{
        .table_header th{
            background-color: #F6F6F6!important;
        }

        .el-table th, .el-table td {
            padding: 0px 0;
            font-size: 12px;
        }

        .el-table__body-wrapper {
            font-size: 13px;
        }
        .el-button.el-button--text {
            font-size: 13px;
            padding: 0px;
        }
        .el-table .cell {
            line-height: 32px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/applyTable.vue